import { render } from "./subRetailerUserList.vue?vue&type=template&id=2b7dd4ca&scoped=true"
import script from "./subRetailerUserList.vue?vue&type=script&lang=js"
export * from "./subRetailerUserList.vue?vue&type=script&lang=js"

import "./subRetailerUserList.vue?vue&type=style&index=0&id=2b7dd4ca&scoped=true&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7dd4ca"]])

export default __exports__